import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import { MaxBrainErrorState } from '../models/error.state';

@Injectable({
    providedIn: 'root',
})
export class HttpErrorStatusGuard {
    constructor(private store: Store) {}

    /**
     * TODO : Write a commentary to explain what this is about,
     * @param next
     * @param state
     */
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const error = this.store.selectSnapshot<HttpErrorResponse>(MaxBrainErrorState.getError);
        const status = next.params['status'];

        if (error && error.status === Number.parseInt(status) && error.status !== 401) {
            return true;
        }

        this.store.dispatch(new Navigate(['/']));
    }
}
